module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 72.033a5246.png";